import React from 'react';
import styles from './Alert.module.css';

const ICONS = { success: 'check_circle', error: 'cancel', warning: 'warning', info: 'info' };

class Alert extends React.Component {
  render() {
    const { type = 'info', title, children, onClose } = this.props;

    return (
      <div className={[styles.alert, styles[type]].join(' ')}>
        <span className={'material-symbols-rounded ' + styles.icon} style={{ fontSize: 16 }}>
          {ICONS[type]}
        </span>
        <div className={styles.content}>
          {title && <div className={styles.title}>{title}</div>}
          {children && <div className={styles.body}>{children}</div>}
        </div>
        {onClose && (
          <button className={styles.close} onClick={onClose}>
            <span className="material-symbols-rounded" style={{ fontSize: 14 }}>close</span>
          </button>
        )}
      </div>
    );
  }
}

export default Alert;
